import { useEffect, useRef } from 'react';
import { render } from 'react-dom';

import './style.scss';
import Style from './Style';
import { getExtension } from './utils/functions';
import { plyrConfig } from './utils/config';

document.addEventListener('DOMContentLoaded', () => {
	const allVideoPlayer = document.querySelectorAll('.wp-block-vpb-video');
	allVideoPlayer.forEach(videoPlayer => {
		const attributes = JSON.parse(videoPlayer.dataset.attributes);

		render(<>
			<Style attributes={attributes} clientId={attributes.clientId} />

			<RenderVideo attributes={attributes} />
		</>, videoPlayer);

		videoPlayer?.removeAttribute('data-attributes')
	});
});

const RenderVideo = ({ attributes }) => {
	const { source, poster, muted } = attributes;

	const videoEl = useRef(null);

	useEffect(() => {
		new Plyr(videoEl.current, plyrConfig(attributes));
	}, []);

	const videoProps = muted ? { muted } : {};

	return <div className='vpbVideoPlayer'>
		<div className='videoWrapper'>
			<video controls playsinline data-poster={poster} preload='metadata' {...videoProps} ref={videoEl}>
				Your browser does not support the video tag.
				<source src={source} type={`video/${getExtension(source) || 'mp4'}`} />
			</video>
		</div>
	</div>
}